export default __webpack_public_path__ + "static/media/002-tongue-depressor-blue.89f643c1.svg";